import { TextQuestionConfig } from '@gripp/shared-logic';
import { RuledLines } from '../components/printPrimitives';
import { RoutinePrintQuestion } from './types';

export const TextPrintQuestion: RoutinePrintQuestion = ({ config }) => {
  const text = config as TextQuestionConfig;
  return <RuledLines count={text.multiline ? 3 : 1} />;
};
